import AgentSignature from '@/components/Common/AgentSignature';

export default {
  name: 'AgentsBelongsToGroupList',

  components: {
    AgentSignature,
  },

  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
    projectUuid: {
      type: String,
      default: null,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/agents/getList',
      ]);
    },
    agentsList() {
      return this.$store.getters['client/project/agents/list'];
    },
  },

  created() {
    const params = {
      group_agents: String(this.group.id),
    };
    this.$store.dispatch('client/project/agents/filterList', {
      params,
      project: this.projectUuid,
      page: -1,
    });
  },
};
